<script setup lang="ts"></script>

<template>
  <div class="p-2 bg-white dark:bg-stone-800 rounded-lg transition-colors duration-150">
    <slot></slot>
  </div>
</template>

<style scoped></style>
